import { Inject, Injectable } from "@angular/core";
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwUserEntity } from "@devwareapps/devware-cap";
import { AcsTestEntity, AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, FlightSchoolApplicantEntity, PilotExaminerEntity } from "../../../meta-data/app-meta-data.service";

@DwCustomContextDefinition({
    keyName: 'checkride-acswrittenresult-acstest-checkride-context',
    display: 'Acs Test Details - Checkride Request',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.CheckRideRequest,
})
@DwCustomContextDefinition({
    keyName: 'checkride-acswrittenresult-acstest-flightschoolapplicant-context',
    display: 'Acs Test Details - Applicant',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.FlightSchoolApplicant,
})
@Injectable()
export class CheckrideAcsWrittenResultAcsTestContextService extends DwCustomContextBase {

     constructor(
            @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        ) {
            super();
        }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextKey = resolvedContext => {
            return this.getAcsTestId(resolvedContext.data);
        };

        contextDef.buildQueryFunction = (contextKey: any) => this.buildQueury(contextKey);

        contextDef.item = AppMetaDataItemNames.AcsTest;
        contextDef.useItemMetaData = true;
    }

    private getAcsTestId(entity: CheckRideRequestEntity | FlightSchoolApplicantEntity): number {
        return entity?.ApplicantAcsWrittenResult?.AcsTestId;
    }

    buildQueury(resolvedContext: any): DwQuery<AcsTestEntity> {

        const acsTestId = this.getAcsTestId(resolvedContext.data);

        const query = AppMetaData.AcsTest.CreateQueryBuilder()
            .addFilterAnd(f => f.Equal(a => a.AcsTestId, acsTestId));

        return query.query;
    }

} 